import { Navigate, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";
import jwtDecode from "jwt-decode";

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = !isEmpty(token) ? jwtDecode(token) : {};
  let location = useLocation();
  if (!isEmpty(user)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};
export const ProtectedRouteLogin = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = !isEmpty(token) ? jwtDecode(token) : {};
  let location = useLocation();
  if (isEmpty(user)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};
